// import './init'
import Form from './form'
import ExtensionService from 'live/services/extension'

const snowFlakePlugin = {
    name: 'Snowflake',
    type: 'snowflake',
    origin: 'Plugin Snowflake',
    roles: ['query'],
    icon: '/content/plugin-snowflake-integration/snowflake-logo.png',
    ui: {
        form: Form,
        view: null
    }
}

ExtensionService.register(snowFlakePlugin)
